<template>
  <div class="data-table">
    <a-table
      :loading="loading"
      :columns="columns"
      :data-source="data"
      :rowKey="(record, index) => index"
      :pagination="false"
    >
      <div slot="dealerInfo" slot-scope="text, record">
        <div class="row-box box-1">
          <div><span>经销商名称：</span></div>
          <div>{{ record.dealer_name || "--" }}</div>
        </div>
        <div class="row-box box-1">
          <div><span>品牌：</span></div>
          <div>{{ record.principal_names || "--" }}</div>
        </div>
        <div class="row-box box-1">
          <div><span>大区/省/市：</span></div>
          <div>{{ record.area_name || "--" }}</div>
        </div>
        <div class="row-box box-1">
          <div><span>分组：</span></div>
          <div>{{ record.account_group_names || "--" }}</div>
        </div>
      </div>
      <div slot="accountInfo" slot-scope="text, record">
        <div class="row-box box-1">
          <div><span>帐号：</span></div>
          <div>{{ record.account || "--" }}</div>
        </div>
        <div class="row-box box-1">
          <div><span>使用人：</span></div>
          <div>{{ record.user_name || "--" }}</div>
        </div>
        <div class="row-box box-1">
          <div><span>联系手机：</span></div>
          <div>{{ record.mobile || "--" }}</div>
        </div>
      </div>
      <div slot="sectionsInfo" slot-scope="text, record">
        <div class="row-box box-1">
          <div><span>总课程：</span></div>
          <div>{{ record.total_sections || "0" }}</div>
        </div>
        <div class="row-box box-1">
          <div><span>已完成：</span></div>
          <div>{{ record.finish_sections || "0" }}</div>
        </div>
        <div class="row-box box-1">
          <div><span>未完成：</span></div>
          <div>{{ record.un_finish_sections || "0" }}</div>
        </div>
      </div>
      <div slot="medalInfo" slot-scope="text, record">
        <div class="row-box box-1">
          <div><span>勋章总数：</span></div>
          <div>{{ record.medal_count || "0" }}</div>
        </div>
        <div class="row-box box-1">
          <div><span>已获取：</span></div>
          <div>{{ record.awarded_medal_count || "0" }}</div>
        </div>
        <div class="row-box box-1">
          <div><span>未获取：</span></div>
          <div>{{ record.un_awarded_medal_count || "0" }}</div>
        </div>
      </div>
      <div slot="awardedInfo" slot-scope="text, record">
        <div class="row-box box-1">
          <div><span>已获取：</span></div>
          <div>{{ record.awarded_certificate_count || '0' }}</div>
        </div>
      </div>
      <div slot="operation" slot-scope="text, record">
        <a @click="handleActionClick('detail', record)">详情</a>
      </div>
    </a-table>
    <!-- 分页配置 -->
    <base-pagination
      :currentPage="pagination.current"
      :pageSize="pagination.pageSize"
      :total="pagination.total"
      @onChange="handlePaginationChange"
      @onShowSizeChange="handlePaginationChange"
    />
  </div>  
</template>

<script>
const columns = [
  {
    title: '经销商信息',
    scopedSlots: {customRender: 'dealerInfo'}
  },
  {
    title: '风火轮帐号信息',
    scopedSlots: {customRender: 'accountInfo'}
  },
  {
    title: '课程学习进度',
    scopedSlots: {customRender: 'sectionsInfo'}
  },
  {
    title: '勋章获取情况',
    scopedSlots: {customRender: 'medalInfo'}
  },
  {
    title: '认证情况',
    scopedSlots: {customRender: 'awardedInfo'}
  },
  {
    title: '操作',
    width: 150,
    align: 'center',
    scopedSlots: {customRender: 'operation'}
  }
]


export default {
  name: 'DataTable',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default () {
        return []
      }
    },
    pagination: {
      type: Object,
      default () {
        return {
          current: 1,
          pageSize: 10,
          total: 0
        }
      }
    }
  },
  data () {
    return {
      columns
    }
  },
  methods: {
    handleActionClick (type, record) {
      this.$emit('action-click', type, record)
    },
    handlePaginationChange (current, pageSize) {
      this.$emit('pagination-change', current, pageSize)
    }
  }
}
</script>

<style lang="scss" scoped>
.row-box {
  display: flex;
  margin-bottom: 5px;

  & > div:first-child {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    font-weight: bold;

    .title {
      display: flex;
      justify-content: space-between;
    }
  }

  & > div:last-child {
    flex: 1;
    min-width: 60px;
  }
}

.box-1 {
  & > div:first-child {
    width: 100px;
  }
}
</style>